export class Ward{
    id : number;
    wardCode : string;
    wardName : string; 
    provinceId : string;
    districtId : number;
}